import React from "react";

import "./Select.scss";

const Select = (props) => {
  const { label, id, children, hasError, errorMessage, required, ...rest } =
    props;
  const selectId = id || `select-${Math.floor(Math.random() * 1000)}`;

  return (
    <div className="box-select">
      {label && (
        <label htmlFor={selectId}>
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}
      <div className={`select ${hasError ? "error-field" : ""}`}>
        <select id={selectId} {...rest}>
          {children}
        </select>
      </div>
      {hasError && errorMessage && (
        <div className="text-danger">{errorMessage}</div>
      )}
    </div>
  );
};

export default Select;
